<template>
  <div class="Lock fixed z-lock w-full h-full bg-backdrop" @click.stop></div>
</template>

<script>
export default {
  name: 'TheLock'
}
</script>
